var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#5B1DEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.829 21.3291H34.1679C34.9046 21.3291 35.5018 21.9263 35.5018 22.663V42.6713H20.829C20.0923 42.6713 19.4951 42.0741 19.4951 41.3374V22.663C19.4951 21.9263 20.0923 21.3291 20.829 21.3291Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.502 26.665H42.1714C42.9081 26.665 43.5053 27.2622 43.5053 27.9989V41.3378C43.5053 42.0745 42.9081 42.6717 42.1714 42.6717H35.502V26.665Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8305 26.4983C24.7384 26.4983 24.6638 26.5729 24.6638 26.665C24.6638 26.7571 24.7384 26.8317 24.8305 26.8317C24.9226 26.8317 24.9973 26.7571 24.9973 26.665C24.9973 26.5729 24.9226 26.4983 24.8305 26.4983",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1665 26.4983C30.0744 26.4983 29.9997 26.5729 29.9997 26.665C29.9997 26.7571 30.0744 26.8317 30.1665 26.8317C30.2585 26.8317 30.3332 26.7571 30.3332 26.665C30.3332 26.5729 30.2585 26.4983 30.1665 26.4983",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8305 31.8332C24.7384 31.8332 24.6638 31.9079 24.6638 32C24.6638 32.092 24.7384 32.1667 24.8305 32.1667C24.9226 32.1667 24.9973 32.092 24.9973 32C24.9973 31.9079 24.9226 31.8332 24.8305 31.8332",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1665 31.8332C30.0744 31.8332 29.9997 31.9079 29.9997 32C29.9997 32.092 30.0744 32.1667 30.1665 32.1667C30.2585 32.1667 30.3332 32.092 30.3332 32C30.3332 31.9079 30.2585 31.8332 30.1665 31.8332",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8305 37.1692C24.7384 37.1692 24.6638 37.2438 24.6638 37.3359C24.6638 37.428 24.7384 37.5026 24.8305 37.5026C24.9226 37.5026 24.9973 37.428 24.9973 37.3359C24.9973 37.2438 24.9226 37.1692 24.8305 37.1692",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1665 37.1692C30.0744 37.1692 29.9997 37.2438 29.9997 37.3359C29.9997 37.428 30.0744 37.5026 30.1665 37.5026C30.2585 37.5026 30.3332 37.428 30.3332 37.3359C30.3332 37.2438 30.2585 37.1692 30.1665 37.1692",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5034 31.8332C39.4113 31.8332 39.3366 31.9079 39.3366 32C39.3366 32.092 39.4113 32.1667 39.5034 32.1667C39.5955 32.1667 39.6701 32.092 39.6701 32C39.6701 31.9079 39.5955 31.8332 39.5034 31.8332",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5034 37.1692C39.4113 37.1692 39.3366 37.2438 39.3366 37.3359C39.3366 37.428 39.4113 37.5026 39.5034 37.5026C39.5955 37.5026 39.6701 37.428 39.6701 37.3359C39.6701 37.2438 39.5955 37.1692 39.5034 37.1692",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.be9ebcd8339ae611dd1d54d6d8a1b4c7.svg";
export { ForwardRef as ReactComponent };